import {CheckoutConfig} from '@spartacus/checkout/base/root';
import {
  AuthConfig,
  CmsConfig,
  ExternalRoutesConfig,
  I18nConfig,
  OccConfig,
  RoutingConfig,
  SiteContextConfig,
  StateConfig,
} from '@spartacus/core';
import {QualtricsConfig} from '@spartacus/qualtrics/components';
import {
  IconConfig,
  LayoutConfig,
  PWAModuleConfig,
  ViewConfig,
} from '@spartacus/storefront';
import {InjectionToken} from '@angular/core';
import {DcpFeatureToggles} from '../product/models/dcp-feature-toggles';
import {DcpCustomConfigModel} from '@app/model/custom-config/dcp-custom-config-model';

export type DcpStorefrontConfig = AuthConfig &
  CmsConfig &
  OccConfig &
  QualtricsConfig &
  StateConfig &
  PWAModuleConfig &
  SiteContextConfig &
  LayoutConfig &
  RoutingConfig &
  I18nConfig &
  IconConfig &
  CheckoutConfig &
  ExternalRoutesConfig &
  ViewConfig &
  DcpFeatureToggles &
  DcpCustomConfigModel;

export const APP_CONFIG = new InjectionToken<DcpStorefrontConfig>('APP_CONFIG');
